var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#496E2D;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "black",
    d: "M367.3,25.4C333.6,9.1,295.9,0,256,0s-77.6,9.1-111.3,25.4L122.4,256l22.3,230.6C178.4,502.9,216.1,512,256,512 s77.6-9.1,111.3-25.4L389.6,256L367.3,25.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.7,25.4C59.1,66.8,0,154.5,0,256s59.1,189.2,144.7,230.6V25.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.3,25.4v461.2C452.9,445.2,512,357.5,512,256S452.9,66.8,367.3,25.4L367.3,25.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,167c-49.2,0-89,39.9-89,89s39.9,89,89,89s89-39.9,89-89S305.2,167,256,167z M256,311.7 c-30.7,0-55.7-24.9-55.7-55.7s24.9-55.7,55.7-55.7s55.7,24.9,55.7,55.7S286.7,311.7,256,311.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,222.6c-12.3,0-22.3,10-22.3,22.3v33.4h44.5v-33.4C278.3,232.6,268.3,222.6,256,222.6L256,222.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/af.3d3a6176cd5e38f4dbd29fd746f5507b.svg";
export { ForwardRef as ReactComponent };